import { StorageService } from '../../vue/services/StorageService'
function checkIfMobile() {
    return /Mobi|Android|iPhone|iPad|iPod/.test(navigator.userAgent);
}

function generateUniqueId() {
    return crypto.getRandomValues(new Uint32Array(4)).join('-');
}


//
// -------------- FP DETECTAR BLOQUEADORES DE CONTENIDO  --------------
// 
function getFilters() {
    const fromB64 = atob; // Decodificaci�n de base64
    return {
        adBlockWarningRemoval: [
            '#adblock-honeypot',
            '.adblocker-root',
            '.wp_adblock_detect',
            fromB64('LmhlYWRlci1ibG9ja2VkLWFk'),
            fromB64('I2FkX2Jsb2NrZXI='),
        ],
        adGuardAnnoyances: [
            '.hs-sosyal',
            '#cookieconsentdiv',
            'div[class^="app_gdpr"]',
            '.as-oil',
            '[data-cypress="soft-push-notification-modal"]',
        ],
        adGuardBase: [
            '.BetterJsPopOverlay',
            fromB64('I2FkXzMwMFgyNTA='),
            fromB64('I2Jhbm5lcmZsb2F0MjI='),
            fromB64('I2NhbXBhaWduLWJhbm5lcg=='),
            fromB64('I0FkLUNvbnRlbnQ='),
        ],
        // Puedes agregar m�s filtros aqu� seg�n sea necesario
    };
}

// Funci�n para verificar si el navegador soporta detecci�n de bloqueadores
function isApplicable() {
    return /AppleWebKit|Android/i.test(navigator.userAgent);
}

// Funci�n para detectar bloqueadores de contenido
async function getDomBlockers() {
    if (!isApplicable()) return undefined;

    const filters = getFilters();
    const selectors = Object.values(filters).flat(); // Todos los selectores de los filtros

    // Crear elementos en el DOM para cada selector y comprobar si est�n bloqueados
    const root = document.createElement('div');
    document.body.appendChild(root);

    const blockedSelectors = {}; // Objeto para almacenar selectores bloqueados

    // Crear cada elemento y verificar si est� bloqueado
    selectors.forEach((selector) => {
        const element = document.createElement('div');
        element.style.cssText = 'display: block; visibility: hidden;';
        element.className = selector.replace(/[.#]/g, ''); // Remover . y # de los selectores
        root.appendChild(element);

        if (!element.offsetParent) {
            blockedSelectors[selector] = true;
        }
        root.removeChild(element);
    });

    document.body.removeChild(root);

    // Obtener los filtros que est�n activos
    const activeBlockers = Object.keys(filters).filter((filterName) => {
        const filterSelectors = filters[filterName];
        const blockedCount = filterSelectors.filter((s) => blockedSelectors[s]).length;
        return blockedCount > filterSelectors.length * 0.6;
    });

    activeBlockers.sort();
    return activeBlockers.length > 0 ? activeBlockers : undefined;
}

// Funci�n para obtener fingerprint de bloqueadores
async function getDomBlockersFingerprint() {
    const blockers = await getDomBlockers();
    return blockers ? blockers.join(',') : 'no-blockers';
}



//
// -------------- FP GEOLOCALIZACION  --------------
// 
async function getGeolocationData() {
    // Obtener el dominio actual del sitio web
    const baseUrl = window.location.origin.indexOf('.com') != -1 ? window.location.origin : 'https://www.pricetravel.com';
    const apiUrl = `${baseUrl}/hotel/api/get-headers-client`;

    try {
        const response = await fetch(apiUrl);
        const geoData = await response.json();

        const geolocationFingerprint = geoData
            ? `country=${geoData.country},region=${geoData.countryRegion},city=${decodeURIComponent(geoData.city)},timezone=${geoData.timeZone},lat=${geoData.latitude},lon=${geoData.longitude},postalcode=${geoData.postalCode}`
            : 'geolocation-unavailable';

        return geolocationFingerprint;

    } catch (error) {
        return 'geolocation-unavailable';
    }
}


//
// -------------- FP PROCESAMIENTO MATEMATICO DEL DEVICE  --------------
// 
function getMathFingerprint() {

    var M = Math; // Para reducir el tama�o del c�digo al usar el objeto Math
    var fallbackFn = function () { return 0; }; // Funci�n de respaldo en caso de que falte alguna operaci�n

    // Operaciones matem�ticas nativas o funciones de respaldo
    var acos = M.acos || fallbackFn;
    var acosh = M.acosh || fallbackFn;
    var asin = M.asin || fallbackFn;
    var asinh = M.asinh || fallbackFn;
    var atanh = M.atanh || fallbackFn;
    var atan = M.atan || fallbackFn;
    var sin = M.sin || fallbackFn;
    var sinh = M.sinh || fallbackFn;
    var cos = M.cos || fallbackFn;
    var cosh = M.cosh || fallbackFn;
    var tan = M.tan || fallbackFn;
    var tanh = M.tanh || fallbackFn;
    var exp = M.exp || fallbackFn;
    var expm1 = M.expm1 || fallbackFn;
    var log1p = M.log1p || fallbackFn;

    // Polyfills de operaciones matem�ticas
    var powPI = function (value) { return M.pow(M.PI, value); };
    var acoshPf = function (value) { return M.log(value + M.sqrt(value * value - 1)); };
    var asinhPf = function (value) { return M.log(value + M.sqrt(value * value + 1)); };
    var atanhPf = function (value) { return M.log((1 + value) / (1 - value)) / 2; };
    var sinhPf = function (value) { return (M.exp(value) - 1 / M.exp(value)) / 2; };
    var coshPf = function (value) { return (M.exp(value) + 1 / M.exp(value)) / 2; };
    var expm1Pf = function (value) { return M.exp(value) - 1; };
    var tanhPf = function (value) { return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1); };
    var log1pPf = function (value) { return M.log(1 + value); };

    // Crear el fingerprint matem�tico con valores espec�ficos para cada operaci�n
    var mathFingerprint = {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154), // 1e308 no funcionar� con el polyfill
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1e300),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1e300),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: powPI(-100),
    };

    return mathFingerprint;
}

//
// -------------- FP FUENTES DISPONIBLES  --------------
// 
function getAvailableFonts() {
    const testString = 'mmMwWLliI0O&1';
    const textSize = '48px';
    const baseFonts = ['monospace', 'sans-serif', 'serif'];
    const fontList = [
        'sans-serif-thin', 'ARNO PRO', 'Agency FB', 'Arabic Typesetting', 'Arial Unicode MS',
        'AvantGarde Bk BT', 'BankGothic Md BT', 'Batang', 'Bitstream Vera Sans Mono', 'Calibri',
        'Century', 'Century Gothic', 'Clarendon', 'EUROSTILE', 'Franklin Gothic', 'Futura Bk BT',
        'Futura Md BT', 'GOTHAM', 'Gill Sans', 'HELV', 'Haettenschweiler', 'Helvetica Neue',
        'Humanst521 BT', 'Leelawadee', 'Letter Gothic', 'Levenim MT', 'Lucida Bright', 'Lucida Sans',
        'Menlo', 'MS Mincho', 'MS Outlook', 'MS Reference Specialty', 'MS UI Gothic', 'MT Extra',
        'MYRIAD PRO', 'Marlett', 'Meiryo UI', 'Microsoft Uighur', 'Minion Pro', 'Monotype Corsiva',
        'PMingLiU', 'Pristina', 'SCRIPTINA', 'Segoe UI Light', 'Serifa', 'SimHei', 'Small Fonts',
        'Staccato222 BT', 'TRAJAN PRO', 'Univers CE 55 Medium', 'Vrinda', 'ZWAdobeF',
    ];

    const holder = document.createElement('div');
    holder.style.fontSize = textSize;
    holder.style.visibility = 'hidden';
    holder.style.position = 'absolute';
    holder.style.top = '0';
    document.body.appendChild(holder);

    const defaultWidth = {};
    const defaultHeight = {};

    // Crear un span con una fuente espec�fica
    function createSpan(fontFamily) {
        const span = document.createElement('span');
        span.style.position = 'absolute';
        span.style.fontFamily = fontFamily;
        span.textContent = testString;
        holder.appendChild(span);
        return span;
    }

    // Obtener dimensiones iniciales de las fuentes base
    const baseFontsSpans = baseFonts.map(createSpan);
    baseFonts.forEach((font, index) => {
        defaultWidth[font] = baseFontsSpans[index].offsetWidth;
        defaultHeight[font] = baseFontsSpans[index].offsetHeight;
    });

    const availableFonts = [];

    // Comprobar cada fuente de la lista
    fontList.forEach(function (font) {
        const fontSpans = baseFonts.map(function (baseFont) {
            return createSpan(`'${font}', ${baseFont}`);
        });

        const isAvailable = baseFonts.some(function (baseFont, index) {
            return fontSpans[index].offsetWidth !== defaultWidth[baseFont] ||
                fontSpans[index].offsetHeight !== defaultHeight[baseFont];
        });

        if (isAvailable) {
            availableFonts.push(font);
        }

        // Limpiar los spans de la fuente actual
        fontSpans.forEach(function (span) {
            holder.removeChild(span);
        });
    });

    // Eliminar los spans de fuentes base y el contenedor
    baseFontsSpans.forEach(function (span) {
        holder.removeChild(span);
    });
    document.body.removeChild(holder);

    return availableFonts;
}


//
// -------------- FP GENERADOR DE MOBILE DEVICE ID   --------------
// 
function getOrCreateMobileDeviceId() {
    // Detecta si el dispositivo es m�vil
    if (!checkIfMobile()) {
        return 'non-mobile-device';
    }

    // Intenta recuperar el ID de localStorage o cookies
    let deviceId = StorageService.get('mobileDeviceId') || getCookie('mobileDeviceId');

    // Si no existe un ID, genera uno nuevo y gu�rdalo
    if (!deviceId) {
        deviceId = generateUniqueId();
        StorageService.set('mobileDeviceId', deviceId);
        setCookie('mobileDeviceId', deviceId, 365); // Validez de 1 a�o
    }
    return deviceId;
}

// Funci�n auxiliar para establecer una cookie
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

// Funci�n auxiliar para obtener una cookie
function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length);
    }
    return null;
}


//
// -------------- AUDIO FINGERPRINT   --------------
// 
function getAudioFingerprint() {
    try {
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioCtx.createOscillator();

        // Configuraci�n b�sica del oscillator para obtener informaci�n del dispositivo
        oscillator.type = 'triangle';
        oscillator.frequency.setValueAtTime(10000, audioCtx.currentTime);

        // Generar el fingerprint usando par�metros del AudioContext y del Oscillator
        const fingerprint = `${audioCtx.sampleRate}-${audioCtx.outputLatency}-${oscillator.type}-${oscillator.frequency.value}`;

        // Limpiar el contexto
        oscillator.disconnect();
        audioCtx.close();

        return fingerprint;
    } catch (error) {
        return 'audio-unavailable';
    }
}


//
// -------------- CANVAS FINGERPRINT --------------
// 
function getCanvasFingerprint() {
    try {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        ctx.textBaseline = "top";
        ctx.font = "16px 'Arial'";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText("fingerprint", 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText("fingerprint", 4, 17);
        return canvas.toDataURL();
    } catch (error) {
        return 'canvas-unavailable';
    }
}

//
// -------------- WEB GL FINGERPRINT --------------
// 
function getWebGLFingerprint() {
    try {
        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) return 'webgl-unavailable';
        var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        var vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        var renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        return vendor + '~' + renderer;
    } catch (error) {
        return 'webgl-unavailable';
    }
}


//
// -------------- INFORMACION DEL NAVEGADOR   --------------
// 
function getSystemInfo() {
    try {
        var memory = navigator.deviceMemory || 'unknown';
        var doNotTrack = navigator.doNotTrack;
        var serviceWorkerSupport = 'serviceWorker' in navigator;
        var touchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        var userAgent = navigator.userAgent;
        var platform = navigator.platform;
        var oscpu = (navigator.oscpu || '');
        var hardwareConcurrency = navigator.hardwareConcurrency;
        var vendor = navigator.vendor;

        return { memory, doNotTrack, serviceWorkerSupport, touchSupport, userAgent, platform, oscpu, hardwareConcurrency, vendor };
    } catch (error) {
        return { memory: 'unavailable', doNotTrack: 'unavailable', serviceWorkerSupport: 'unavailable', touchSupport: 'unavailable' };
    }
}

//
// -------------- MIME TYPES   --------------
// 
function getMimeTypes() {
    try {
        return Array.from(navigator.mimeTypes).map(mime => mime.type).join(',');
    } catch (error) {
        return 'mime-types-unavailable';
    }
}

//
// -------------- NETWORK INFORMATION   --------------
// 
function getNetworkInfo() {
    try {
        if ('connection' in navigator) {
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            return `connectionType=${connection.effectiveType},rtt=${connection.rtt}`;
        }
        return 'network-unavailable';
    } catch (error) {
        return 'network-unavailable';
    }
}


//
// -------------- TOUCH SUPPORT  --------------
// 
function getTouchSupport() {
    try {
        const touchSupport = {
            touchEvent: 'ontouchstart' in window,
            maxTouchPoints: navigator.maxTouchPoints || 0
        };

        return `touchEvent=${touchSupport.touchEvent},maxTouchPoints=${touchSupport.maxTouchPoints}`;
    } catch (error) {
        return 'touch-support-unavailable';
    }
}

//
// -------------- API SUPPORT INFORMATION  --------------
// 
function getApiSupportInfo() {
    try {
        const supportInfo = {
            webGL2: !!window.WebGL2RenderingContext,
            webRTC: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
            vibrate: !!navigator.vibrate,
            serviceWorker: 'serviceWorker' in navigator,
            indexedDB: 'indexedDB' in window,
            battery: 'getBattery' in navigator
        };

        return `webGL2=${supportInfo.webGL2},webRTC=${supportInfo.webRTC},vibrate=${supportInfo.vibrate},serviceWorker=${supportInfo.serviceWorker},indexedDB=${supportInfo.indexedDB},battery=${supportInfo.battery}`;
    } catch (error) {
        return 'api-support-unavailable';
    }
}

//
// -------------- SCREEN INFORMATION  --------------
// 
function getScreenInfo() {
    try {
        const screenInfo = {
            width: screen.width,
            height: screen.height,
            availWidth: screen.availWidth,
            availHeight: screen.availHeight,
            colorDepth: screen.colorDepth,
            pixelDepth: screen.pixelDepth,
            devicePixelRatio: window.devicePixelRatio
        };

        // Crear una cadena de informaci�n de pantalla para el fingerprint
        return `width=${screenInfo.width},height=${screenInfo.height},availWidth=${screenInfo.availWidth},availHeight=${screenInfo.availHeight},colorDepth=${screenInfo.colorDepth},pixelDepth=${screenInfo.pixelDepth},devicePixelRatio=${screenInfo.devicePixelRatio}`;
    } catch (error) {

        return 'screen-info-unavailable';
    }
}


//
// -------------- IDIOMAS DEL NAVEGADOR  --------------
// 

// Verifica si el navegador es Chromium
function isChromium() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}

// Verifica si la versi�n de Chromium es 86 o superior
function isChromium86OrNewer() {
    const match = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\./);
    return match ? parseInt(match[1], 10) >= 86 : false;
}


function getLanguages() {
    const n = navigator;
    const result = [];

    const language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) {
        result.push([language]);
    }

    if (Array.isArray(n.languages)) {
        if (!(isChromium() && isChromium86OrNewer())) {
            result.push(n.languages);
        }
    } else if (typeof n.languages === 'string') {
        const languages = n.languages;
        if (languages) {
            result.push(languages.split(','));
        }
    }

    return result;
}

//
// -------------- FUNCION PRINCIPAL  --------------
// 
export async function getBrowserFingerprint() {
    try {


        var screenResolution = (screen.width && screen.height) ? screen.width + "x" + screen.height : 'screen-resolution-unavailable';
        var plugins = navigator.plugins ? Array.from(navigator.plugins).map(p => p.name).join(',') : 'plugins-unavailable';
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'timezone-unavailable';
        var cookieEnabled = navigator.cookieEnabled || false;
        var localStorageSupport = typeof localStorage !== 'undefined';
        var sessionStorageSupport = typeof sessionStorage !== 'undefined';
        var hardwareConcurrency = navigator.hardwareConcurrency || 'hardware-concurrency-unavailable';
        var appVersion = navigator.appVersion || 'app-version-unavailable';

        var audioFingerprint = getAudioFingerprint();
        var canvasFingerprint = getCanvasFingerprint();
        var webGLFingerprint = getWebGLFingerprint();
        var systemInfo = JSON.stringify(getSystemInfo());
        var mimeTypes = getMimeTypes();
        var networkInfo = getNetworkInfo();
        var touchSupport = getTouchSupport();
        var apiSupportInfo = getApiSupportInfo();
        var screenInfo = getScreenInfo();
        var mobileDeviceId = getOrCreateMobileDeviceId();
        var mathFingerprint = JSON.stringify(getMathFingerprint());
        var fonts = JSON.stringify(getAvailableFonts());
        var geolocationData = JSON.stringify(await getGeolocationData());
        var domBlockersFingerprint = await getDomBlockersFingerprint();
        var languages = JSON.stringify(getLanguages());
        var deviceType = checkIfMobile() ? "mbl" : "dsk";


        // Combinar toda la informaci�n en una cadena �nica
        var fingerprintString = fonts + domBlockersFingerprint + mobileDeviceId + screenResolution + plugins + timezone + cookieEnabled + localStorageSupport + sessionStorageSupport + hardwareConcurrency + appVersion + audioFingerprint + canvasFingerprint + webGLFingerprint + systemInfo + mimeTypes + networkInfo + touchSupport + apiSupportInfo + screenInfo + mathFingerprint + geolocationData + languages;

        // Generar el hash SHA-256 del fingerprint
        return crypto.subtle.digest("SHA-256", new TextEncoder().encode(fingerprintString)).then(buffer => {
            var hashArray = Array.from(new Uint8Array(buffer));
            var hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            return deviceType + hashHex; // Este es el ID �nico persistente basado en las caracter�sticas del dispositivo
        });
    } catch (error) {
        return 'fingerprint-generation-failed';
    }
}

